import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Footer = props => {
  var {
      name = 'footer'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    name: "footer",
    tagName: "footer"
  }));
};
Footer.displayName = 'Login.Footer';